var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgTwitter = function SvgTwitter(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#111111"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5997 5H19.0543L13.6932 11.126L20 19.4633H15.063L11.1934 14.4081L6.77097 19.4633H4.31291L10.0461 12.9096L4 5H9.06215L12.5563 9.6206L16.5997 5ZM15.7375 17.9961H17.0969L8.3216 6.3907H6.86136L15.7375 17.9961Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgTwitter);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iNCIgZmlsbD0iIzExMTExMSIvPgo8cGF0aCBkPSJNMTYuNTk5NyA1SDE5LjA1NDNMMTMuNjkzMiAxMS4xMjZMMjAgMTkuNDYzM0gxNS4wNjNMMTEuMTkzNCAxNC40MDgxTDYuNzcwOTcgMTkuNDYzM0g0LjMxMjkxTDEwLjA0NjEgMTIuOTA5Nkw0IDVIOS4wNjIxNUwxMi41NTYzIDkuNjIwNkwxNi41OTk3IDVaTTE1LjczNzUgMTcuOTk2MUgxNy4wOTY5TDguMzIxNiA2LjM5MDdINi44NjEzNkwxNS43Mzc1IDE3Ljk5NjFaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";